import { IHype } from "../../pages/hypes/Hypes";
import { useLocale } from "../../services/DataContext";


export interface HypeCardProps {
  className?: string;
  item: IHype;
}

export const HypeCard: React.FC<HypeCardProps> = ({ item, className }) => {
  const l: any = useLocale();
  return <div className={`hype-card ${className || ""}`}>
    <div className="hype-card__col hype-card__col--rank">
      <p>{item.rank}</p>
    </div>
    <div className="hype-card__col hype-card__col--name">
      <div className="hype-card__row">
        <h3 className="strong">{item.name}</h3>
      </div>
      <div className="hype-card__row">
        <HypeSecondary label={l["hypeScore"]} score={item.hypeScore} />
      </div>
      <div className="hype-card__row">
        <HypeSecondary label={l["releaseScore"]} score={item.releaseScore} />
      </div>
    </div>
    <div className="hype-card__col hype-card__col--diff">
      <div className="hype-card__right hype-card__right--number">
        <p>
          {item.difference}
        </p>
      </div>
      <div className="hype-card__right hype-card__right--symbol">
        {
          item.difference < 0 &&
          <i className="icon-thumb_down_alt red" />
        }
        {
          item.difference > 0 &&
          <i className="icon-thumb_up_alt green" />
        }
        {
          item.difference === 0 &&
          <i className="icon-remove green" />
        }
      </div>
    </div>
  </div>
}

interface HypeSecondaryProps {
  label: string;
  score: number;
}

const HypeSecondary: React.FC<HypeSecondaryProps> = (props) => {
  return <div className="hype-secondary">
    <div className="hype-secondary__block">
      <div className="hype-secondary__progress">
        <div className="hype-secondary__item hype-secondary__col--label">
          <h4 className="font-light">{props.label}</h4>
        </div>
        <div className="hype-secondary__item hype-secondary__col--bar">
          <HypeBar width={props.score} />
        </div>
      </div>
      <div className="hype-secondary__value">
        <p>{props.score}</p>
      </div>
    </div>
  </div>
}


interface HypeBarProps {
  width: number;
}

const HypeBar: React.FC<HypeBarProps> = (props) => {
  return <div className="hype-bar">
    <div className="hype-bar__progress" style={{ width: props.width + "%" }}></div>
  </div>
}